import { useEffect, useMemo, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import QRCode from "qrcode";

export default function SelfRegisterQRPage() {
  const { user } = useAuth();
  const hospitalId = user?.hospitalId ?? "";

  const link = useMemo(() => {
    const base = window.location.origin.replace(/\/+$/, "");
    return `${base}/self-register?h=${encodeURIComponent(hospitalId)}`;
  }, [hospitalId]);

  const [qrDataUrl, setQrDataUrl] = useState<string>("");

  useEffect(() => {
    async function generate() {
      try {
        if (!hospitalId) return;
        const url = `${window.location.origin.replace(/\/+$/, "")}/self-register?h=${encodeURIComponent(hospitalId)}`;
        const dataUrl = await QRCode.toDataURL(url, { margin: 1, width: 320 });
        setQrDataUrl(dataUrl);
      } catch (e: any) {
        toast.error(e?.message || "Failed to generate QR");
      }
    }
    generate();
  }, [hospitalId]);

  return (
    <div className="p-6">
      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>Self Registration QR (Hospital)</CardTitle>
          <div className="text-sm text-muted-foreground">Patients can scan this QR and self-register (no OTP, no OPD appointment).</div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-1">
            <div className="text-xs font-medium text-muted-foreground">Self-register link</div>
            <div className="text-sm break-all">{hospitalId ? link : "Your user is not linked to a hospital."}</div>
          </div>

          {qrDataUrl && (
            <div className="border rounded-md p-4 bg-white inline-block">
              <img src={qrDataUrl} alt="Self registration QR" className="w-64 h-64" />
            </div>
          )}

          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(link);
                  toast.success("Link copied");
                } catch {
                  toast.error("Copy failed");
                }
              }}
              disabled={!hospitalId}
            >
              Copy link
            </Button>
            <Button
              onClick={() => {
                if (!hospitalId) return;
                if (!qrDataUrl) return;
                const a = document.createElement("a");
                a.href = qrDataUrl;
                a.download = `self-register-qr-${hospitalId}.png`;
                a.click();
              }}
              disabled={!hospitalId}
            >
              Download QR PNG
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

